// @vendors
import { useState, useId, useMemo, useContext } from 'react'

// @components material
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
} from "../../components/shared/MaterialUI";

// @style
import { StyleAPiClient } from './StyleApiClient';

// @components
import RowClient from './RowClient';
import CreateClientModal from './CreateClientModal';
import ToolbarClients from './components/ToolbarClients';
import { TablePaginationActions } from '../Admin/components/custom/TablePaginationActions';

// @constants
import { ClientContext } from './ApiClients';

const TableApiClient = () => {
  const styles = useMemo(() => StyleAPiClient(), []);
  const idTable = useId();
  const [openModal, setOpenModal] = useState(false);
  const {
    rowsState,
    getAllClients,
    setRowsState,
  } = useContext(ClientContext);

  const openModalCreate = () =>{
    setOpenModal(current => !current);
  }

  const handlePageChange = (event, nextPage) => {
    const page = nextPage === 0 ? 1 : nextPage === rowsState.currentPage ? nextPage + 1 : nextPage
    setRowsState((prev) => ({
      ...prev,
      currentPage: parseInt(page),
      pageSize:rowsState.pageSize
    }));
    getAllClients({page: page, size: parseInt(rowsState.pageSize)})
  };

  const handlePageSizeChange = (event) => {
    setRowsState((prev) => ({
      ...prev,
      currentPage: 1,
      pageSize: event.target.value
    }));
    getAllClients({size:event.target.value})
  };

  return (
    <Paper elevation={4}>
      <ToolbarClients openModalCreate={openModalCreate} />

      <TableContainer sx={styles.tableContainer} component={Paper}>
        <Table aria-label="collapsible table" stickyHeader>
          <TableHead>
            <TableRow sx={styles.tableRow} key={idTable}>
              <TableCell sx={styles.emptyTableCell} />
              <TableCell sx={styles.tableHeadTitle}>Client name</TableCell>        
            </TableRow>
          </TableHead>

          <TableBody sx={styles.tableBody}>
            {rowsState?.rows?.map((client, index) => (
              <RowClient key={index} row={client}/>
            ))}            
          </TableBody>
        </Table>
      </TableContainer>

      <TablePagination
        component="div"
        rowsPerPageOptions={[10, 20, 50]}
        colSpan={3}
        count={rowsState.rowCount || 0}
        rowsPerPage={parseInt(rowsState.pageSize)}
        page={rowsState.page}
        onPageChange={handlePageChange}
        onRowsPerPageChange={(e) => handlePageSizeChange(e)}
        ActionsComponent={() => TablePaginationActions(rowsState.rowCount, rowsState.currentPage, rowsState.pageSize, handlePageChange)}
        SelectProps={{
          inputProps: {"aria-label": "rows per page"},
          native: true,
        }}
      />
      <CreateClientModal open={openModal} onClose={openModalCreate} getAllClients={getAllClients} />
    </Paper>
  )
}

export default TableApiClient